import { TSelect } from "@/models/company_subscription";
import { SMUser } from "@/store";

export const SUBSCRIPTION_STATUS_TRIAL = "Trial";
export const SUBSCRIPTION_STATUS_ACTIVE = "Active";
export const SUBSCRIPTION_STATUS_BLOCKED = "Blocked";

export const SUBSCRIPTION_STATUSES: TSelect[] = [
  { value: SUBSCRIPTION_STATUS_TRIAL, label: SUBSCRIPTION_STATUS_TRIAL },
  { value: SUBSCRIPTION_STATUS_ACTIVE, label: SUBSCRIPTION_STATUS_ACTIVE },
  { value: SUBSCRIPTION_STATUS_BLOCKED, label: SUBSCRIPTION_STATUS_BLOCKED },
];

export const COMPLIANCE_PACKAGE_BASIC = "Basic";
export const COMPLIANCE_PACKAGE_BASIC_PLUS = "Basic Plus";
export const COMPLIANCE_PACKAGE_PREMIUM = "Premium";

export const COMPLIANCE_PACKAGES: TSelect[] = [
  {
    value: COMPLIANCE_PACKAGE_BASIC,
    label: COMPLIANCE_PACKAGE_BASIC,
  },
  {
    value: COMPLIANCE_PACKAGE_BASIC_PLUS,
    label: COMPLIANCE_PACKAGE_BASIC_PLUS,
  },
  {
    value: COMPLIANCE_PACKAGE_PREMIUM,
    label: COMPLIANCE_PACKAGE_PREMIUM,
  },
];

export const isIncludedInPackage = (service: string) => {
  if (SMUser.isPremiumSubscription)
    return ["Increase CoS Allocation", "Mock Audit", "Paid Consultation"].includes(service);

  if (SMUser.isStandardSubscription) return ["Paid Consultation"].includes(service);

  return false;
};
